import Model from "../Model";

class KpiGraphsComercialClientZone extends Model{

    buildUrl ({ param }) {
        return ['kpizoneclientview/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiGraphsComercialClientZone;